import { toggleClass } from '@utils/domUtils';

export default class JobStatsTable {
  static selectorString() {
    return '.JobStatsTable';
  }

  render(node, props) {
    [...node.querySelectorAll('.has-details')].forEach(element =>
      element.addEventListener('click', this.toggleDetails.bind(this)),
    );
  }

  toggleDetails(event) {
    const jobId = event.currentTarget.getAttribute('data-job');
    const detailsTable = this.node.querySelector(`.job-details-table[data-job="${jobId}"]`);
    toggleClass(detailsTable, 'd-none');
  }
}
